import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import { useCurrentAccountStore } from "@/stores/currentAccount"

export interface IJuniferMutator {
  openUI(): MutationResult<unknown>
}

class JuniferMutatorClass implements IJuniferMutator {
  openUI() {
    return useMutation({
      ...BackofficeRestMutations.account.openJuniferUi(),
      serializerFn: (): number => {
        const billingAccountId = useCurrentAccountStore().coreId.data
        if (billingAccountId == null) throw new Error("Missing coreId")

        return billingAccountId
      },
      // Opening a window in Junifer changes nothing Nova displays.
      invalidateCache: false,
    })
  }
}

export const JuniferMutator = new JuniferMutatorClass()
